import { useEffect } from "react";

export const SITE = "https://changeos.co";

const upsert = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) { el = document.createElement(attrs.tag || "meta"); document.head.appendChild(el); }
  Object.entries(attrs).forEach(([k, v]) => { if (k !== "tag") el.setAttribute(k, v); });
};

// SPA head management without a dependency: title, description, canonical and Open Graph per marketing page. Canonical host is always changeos.co.
export default function useSeo({ title, description, path, image = `${SITE}/og-image.png` }) {
  useEffect(() => {
    const full = title.includes("ChangeOS") ? title : `${title} | ChangeOS`;
    const url = `${SITE}${path === "/" ? "/" : path.replace(/\/$/, "")}`;
    document.title = full;
    upsert('meta[name="description"]', { name: "description", content: description });
    upsert('link[rel="canonical"]', { tag: "link", rel: "canonical", href: url });
    upsert('meta[property="og:title"]', { property: "og:title", content: full });
    upsert('meta[property="og:description"]', { property: "og:description", content: description });
    upsert('meta[property="og:url"]', { property: "og:url", content: url });
    upsert('meta[property="og:type"]', { property: "og:type", content: "website" });
    upsert('meta[property="og:site_name"]', { property: "og:site_name", content: "ChangeOS" });
    upsert('meta[property="og:image"]', { property: "og:image", content: image });
    upsert('meta[property="og:image:width"]', { property: "og:image:width", content: "1200" });
    upsert('meta[property="og:image:height"]', { property: "og:image:height", content: "630" });
    upsert('meta[name="twitter:card"]', { name: "twitter:card", content: "summary_large_image" });
    upsert('meta[name="twitter:title"]', { name: "twitter:title", content: full });
    upsert('meta[name="twitter:description"]', { name: "twitter:description", content: description });
    upsert('meta[name="twitter:image"]', { name: "twitter:image", content: image });
  }, [title, description, path, image]);
}
